import PropertyCarousel from './PropertyCarousel'
import SimpleCarousel from './SimpleCarousel'

export { PropertyCarousel, SimpleCarousel }

export default SimpleCarousel